module.exports = __webpack_public_path__ + "img/jpBanner2.d19eac8c.png";